import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Checkbox, Spin } from "antd";
import classNames from "classnames";
function TreeNodeItem({ id, attr, className, title, count, inputValue, isCreateNode, isRenaming, isSortable, isUlVisible, isExpanded, togglable, emptySortableUl, busy, checked, indeterminate, checkable, saveLabel, iconNode, handleRef, handleSelect, handleToggle, handleNodeKeyDown, handleInputKeyDown, handleInputChange, handleButtonSave, handleCheck, renderChildren }) {
    return /*#__PURE__*/ _jsxs("li", {
        className: classNames({
            "aiot-sortable": isSortable
        }),
        "data-li-id": id,
        children: [
            /*#__PURE__*/ _jsx(Spin, {
                spinning: busy,
                size: "small",
                children: /*#__PURE__*/ _jsxs("div", {
                    "data-id": id,
                    tabIndex: 0,
                    className: className,
                    onClick: isCreateNode ? undefined : handleSelect,
                    onDoubleClick: isCreateNode || !togglable ? undefined : handleToggle,
                    onKeyDown: handleNodeKeyDown,
                    ...attr,
                    ref: handleRef,
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "aiot-node-icon",
                            children: [
                                iconNode,
                                checkable && /*#__PURE__*/ _jsx(Checkbox, {
                                    checked: checked && !indeterminate,
                                    indeterminate: indeterminate,
                                    onChange: handleCheck
                                })
                            ]
                        }),
                        isRenaming ? /*#__PURE__*/ _jsx("input", {
                            autoFocus: true,
                            className: "aiot-node-name",
                            value: inputValue,
                            onChange: handleInputChange,
                            onKeyDown: handleInputKeyDown
                        }) : /*#__PURE__*/ _jsx("div", {
                            className: "aiot-node-name",
                            title: title,
                            children: title
                        }),
                        count > 0 && !isRenaming && /*#__PURE__*/ _jsx("div", {
                            className: "aiot-node-count",
                            children: count
                        }),
                        isRenaming && /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            disabled: !inputValue,
                            onClick: ()=>handleButtonSave(true),
                            children: saveLabel
                        })
                    ]
                })
            }),
            isUlVisible && renderChildren(),
            emptySortableUl,
            togglable && /*#__PURE__*/ _jsx("div", {
                onClick: handleToggle,
                className: classNames("aiot-expander", {
                    "aiot-open": isExpanded
                })
            })
        ]
    });
}
export { TreeNodeItem };
